import KYC from './kyc';

export const KYCConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth    : ['super', 'investors', 'staff', 'kyc'],
    routes  : [
        {
            path     : '/kyc',
            component: KYC
        }
    ]
};
